<template lang='pug'>
.tableTop10Grid-body
  TableItem(v-for='(info, idx) in infos' :key='idx' :info="info")
</template>
<script>
import TableItem from '@/components/modules/table_grid/table_item.vue'
export default {
  components: {
    TableItem
  },
  props: {
    infos: Array
  }
}
</script>